import buildExplore from "./parts/league/past/buildExplore";

(() => {
  buildExplore();
})();
